<template>
  <div class="t-priceCalculator">
    <div class="steps" @click="configuratorStartsEvent">
      <div :key="step.Id" v-for="step in steps" class="step" v-show="!step.HideForUser">
        <div class="stepImage -showForMd">
          <img :v-if="step.Picture && step.Picture.Src"
               v-bind:src="
              step.newPic ||
              (step.selectedOption
                ? step.selectedOption.Picture
                  ? step.selectedOption.Picture.Src
                  : false
                : false) ||
              step.Picture.Src
            " />
        </div>
        <div class="stepInfo">
          <h3>
            {{ step.Title }}
          </h3>
          <div class="stepDesc" v-html="step.Description">

          </div>

  <Option v-if="step.Type === 'price-calculator-step'"
          :content="{
              step: step,
              labels: step.Labels,
              unavailableLabel: confConfig.Labels.SelectionUnavailableLabel,
            }"
          @select-option="selectOption"
          @set-image="setStepPicture"
          @unset-image="unsetStepPicture" />
  <span v-if="step.Type !== 'price-calculator-size-step'"
        class="stepInfoMore"
        :class="{ '-active': step.moreInfo }"
        @click="step.moreInfo = !step.moreInfo">
    <span class="activeText">
      {{ confConfig.Labels.MoreInfoActiveLabel }}
    </span>
    <span class="inactiveText">
      {{ confConfig.Labels.MoreInfoLabel }}
    </span>
  </span>
  </div>
  <SizeStep v-if="step.Type === 'price-calculator-size-step'"
            :content="{ step: step, labels: step.Labels }"
            @select-option="selectOption" />
  </div>
  </div>
  <Product :content="{
        labels: confConfig.Labels,
        product: product,
        loading: loading,
        steps: steps,
        prodImg: confConfig.TopRightImage ? confConfig.TopRightImage.Src : null,
        additionalProds: confResponse
          ? confResponse.AdditionalProducts
            ? confResponse.AdditionalProducts
            : null
          : null,
        isVatIncluded: confConfig.InclVat,
      }"
           @add-to-basket="addToBasket"
           @reset="reset" />
  </div>
</template>

<script>
  import SizeStep from "./SizeStep";
  import Option from "./Option";
  import Product from "./Product";
  const axios = require("axios").default;

  export default {
    name: "Configurator",
    data() {
      var cfg = null;
      if (window.rwpc) {
        cfg = window.rwpc.config;
        cfg.Labels.VatText = cfg.InclVat
          ? cfg.Labels.InclVatText
          : cfg.Labels.ExclVatText;
      }
      return {
        confResponse: null,
        loading: 0,
        confConfig: cfg,
        stepSelection: [],
      };
    },
    computed: {
      steps() {
        if (this.confResponse) {
          this.confConfig.Steps.forEach((step) => {
            const resultOptions = this.confResponse.Attributes[step.Id];

            step.Options.forEach(function (option) {
              // Setting the validity of the step based on the API response
              option.isValid =
                resultOptions && resultOptions.indexOf(option.Id) > -1;

              //check the first option of each step: PBI: 44123
              if (option.isValid) {
              }
            });
          });
        } else {
          this.confConfig.Steps.forEach(function (step) {
            step.Options.forEach(function (option) {
              // Defaulting all steps to invalid
              option.isValid = false;
            });
          });
        }

        return this.confConfig.Steps;
      },
      product() {
        if (this.confResponse && this.confResponse.Products) {
          return this.confResponse.Products[0];
        }
        return null;
      },
    },
    components: {
      SizeStep,
      Option,
      Product,
    },
    methods: {
      selectOption(step, option, skipConfigure = false) {
        step.selectedOption = option;
        const attrs = {};
        let wSize = "";

        this.confConfig.Steps.forEach(function (step) {
          if (step.selectedOption && step.Id) {
            attrs[step.Id] = step.selectedOption.Id;
            if (step.PicassoField === "TypeSignSize") {
              wSize = step.selectedOption.Lookup;
            }
          }
        });

        const data = {
          attributes: attrs,
          configuratorId: this.confConfig.ConfiguratorId,
          windowSize: wSize,
        };

        if (!skipConfigure) {
          this.configure(data);
        }
      },
      setStepPicture(step, pictureSrc) {
        // You're not my real picture, you'te just my step picture
        step.prevPic = step.Picture.Src;
        if (pictureSrc) {
          step.newPic = pictureSrc;
        }
      },
      unsetStepPicture(step) {
        if (step.prevPic) {
          delete step.newPic;
        }
      },
      configure: function (data) {
        this.loading++;
        axios
          .post(
            //       this.confConfig.Domain +
            //     "//" + window.location.hostname +
            "/api/sitecore/windowspricecalculator/configure",
            data
          )
          .then((response) => {
            // Loop through each step to set the isValid state of each option
            this.confResponse = response.data;
            this.confConfig.Labels.VatText = this.confConfig.InclVat
              ? this.confConfig.Labels.InclVatText
              : this.confConfig.Labels.ExclVatText;
            this.loading--;
          })
          .catch(function (error) {
            console.error(error);
          });
      },
      addToBasket() {
        var url = this.confConfig.RedirectPage ? this.confConfig.RedirectPage.Url : '';
        location.href =
          url + "?id=" + this.product.Id.replaceAll(" ", "-");
      },
      reset() {
        this.confConfig.Steps.forEach(function (step) {
          if (step.selectedOption) {
            delete step.selectedOption;
          }
        });

        if (this.confResponse) {
          delete this.confResponse;
        }
      },
      // GA4 tracking
      configuratorStartsEvent() {
        var dataLayer = window.dataLayer || [];

        const now = new Date();
        const timestamp = `${now.toISOString().slice(0, 10)} ${now.toTimeString().slice(0, 8)}.${now.getMilliseconds().toString().padStart(3, '0')}`;

        var isEventPresent = window.dataLayer.some(function (obj) {
                return obj.event === "configurator_starts_ga4";
            });

        if (!isEventPresent) {
        dataLayer.push({
          event: "configurator_starts_ga4",
          timestamp: timestamp,
          site_section: "Main configurator",
        });

      }
      }
    },
  };
</script>

<style lang="scss">
  @import "../style/_elements";
  @import "../style/_vars";

  .t-priceCalculator {
    display: flex;
    flex-flow: row wrap;

    img {
      max-width: 100%;
    }

    @include respond-above(sm) {
      margin: 0 3rem;
    }
  }

  .steps {
    width: 100%;

    @include respond-above(sm) {
      width: 66.66666666%;
    }
  }

  .step {
    border: 1px solid gray;
    padding: 1rem;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
    margin-bottom: 2rem;
    display: flex;
    flex-flow: row wrap;

    @include respond-below(sm) {
      position: relative;
      padding-bottom: 2rem;
    }

    &Desc {
      margin-bottom: 1rem;
    }

    &Image {
      padding: 0.5rem;
      box-sizing: border-box;
      width: 25%;
    }

    &Info {
      width: 100%;

      @include respond-above(sm) {
        width: 75%;
      }

      padding: 0.5rem;
      box-sizing: border-box;

      &More {
        cursor: pointer;
        text-decoration: underline;
        color: gray;

        @include respond-below(sm) {
          position: absolute;
          left: 0;
          right: 0;
          text-align: center;
          line-height: 2rem;
          bottom: 0;
        }

        &:after {
          content: "";
          display: inline-block;
          border-top: 0.5em solid gray;
          border-right: 0.5em solid transparent;
          border-bottom: 0.5em solid transparent;
          border-left: 0.5em solid transparent;
          transform: translateY(50%);
          margin-left: 0.25em;
          transform-origin: 50% 25%;
          transition: 0.3s transform;
        }

        &.-active {
          &:after {
            transform: translateY(50%) rotate(180deg);
          }

          .activeText {
            display: inline-block;
          }

          .inactiveText {
            display: none;
          }
        }

        .activeText {
          display: none;
        }

        .inactiveText {
          display: inline-block;
        }
      }
    }
  }

  .-loading {
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translate3d(-50%,-50%, 0);
    top: 50%;
    text-align: center;
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    color: transparent;
    animation: dot-flashing 1s infinite linear alternate;
    animation-delay: 0.5s;

    &::before,
    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
    }

    &::before {
      left: -0.75em;
      width: 0.5em;
      height: 0.5em;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.2);
      color: rgba(255, 255, 255, 0.2);
      animation: dot-flashing 1s infinite alternate;
      animation-delay: 0s;
    }

    &::after {
      left: 0.75em;
      width: 0.5em;
      height: 0.5em;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.2);
      color: rgba(255, 255, 255, 0.2);
      animation: dot-flashing 1s infinite alternate;
      animation-delay: 1s;
    }
  }

  .optionDesc {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
    margin-bottom: 1rem;
    font-weight: 100;

    &.-show {
      max-height: 1000px;
      transition: max-height 1s ease-in-out;
    }
  }

  @keyframes dot-flashing {
    0% {
      background-color: rgba(255, 255, 255, 1);
    }

    50%, 100% {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
</style>
